var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Picker',{attrs:{"data":_vm.emojiIndex,"native":true,"show-preview":false,"show-skin-tones":true,"per-line":8,"emoji-size":22,"i18n":_vm.pickerI18n,"title":""},on:{"select":_vm.onSelect}})}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }